import Factory from "../../common/utils/Factory";
import { INearService } from "./service/near/INearService";
import NearService from "./service/near/NearService";
import { default as config } from "common/config/config";

export interface IServiceFactory {
    nearService: INearService;
}
// @ts-ignore - avoid breaking the application
export default Factory<IServiceFactory>({
    nearService: () => new NearService(config.nearNetwork),
});
